import globalAxios from 'axios';
import { createRequestFunction, assertParamExists, DUMMY_BASE_URL, setSearchParams, toPathString, setApiKeyToObject } from '../common.mjs';
import { BASE_PATH, BaseAPI } from '../base.mjs';
import { makeRemoteWithOpenapiGenerator } from '@flex-packages/remote-core';

const ApplicationPathTagPublicControllerApiAxiosParamCreator = function(configuration) {
  return {
    /**
     * 
     * @summary 지원경로 조회 API
     * @param {ApplicationPathTagPublicControllerApiGetApplicationPathTagsPublicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getApplicationPathTagsPublic: ({ customerIdHash }, options = {}) => {
      assertParamExists("getApplicationPathTagsPublic", "customerIdHash", customerIdHash);
      const localVarPath = `/api-public/v2/recruiting/customers/{customerIdHash}/application-path-tags`.replace(`{${"customerIdHash"}}`, encodeURIComponent(String(customerIdHash)));
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }
      const localVarRequestOptions = { method: "GET", ...baseOptions, ...options };
      const localVarHeaderParameter = {};
      const localVarQueryParameter = {};
      setApiKeyToObject(localVarHeaderParameter, "x-flex-aid", configuration);
      setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = { ...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers };
      return {
        ...localVarRequestOptions,
        identifier: "getApplicationPathTagsPublic",
        url: toPathString(localVarUrlObj)
      };
    }
  };
};
const ApplicationPathTagPublicControllerApiFp = function(configuration) {
  const localVarAxiosParamCreator = ApplicationPathTagPublicControllerApiAxiosParamCreator(configuration);
  return {
    /**
     * 
     * @summary 지원경로 조회 API
     * @param {ApplicationPathTagPublicControllerApiGetApplicationPathTagsPublicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getApplicationPathTagsPublic(requestParameters, options) {
      const localVarAxiosArgs = localVarAxiosParamCreator.getApplicationPathTagsPublic(requestParameters, options);
      return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH);
    }
  };
};
const ApplicationPathTagPublicControllerApiFactory = function(configuration, basePath, axios) {
  const localVarFp = ApplicationPathTagPublicControllerApiFp(configuration);
  return {
    /**
     * 
     * @summary 지원경로 조회 API
     * @param {ApplicationPathTagPublicControllerApiGetApplicationPathTagsPublicRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    getApplicationPathTagsPublic(requestParameters, options) {
      return localVarFp.getApplicationPathTagsPublic(requestParameters, options)(axios, basePath);
    }
  };
};
class ApplicationPathTagPublicControllerApi extends BaseAPI {
  /**
   * 
   * @summary 지원경로 조회 API
   * @param {ApplicationPathTagPublicControllerApiGetApplicationPathTagsPublicRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof ApplicationPathTagPublicControllerApi
   */
  getApplicationPathTagsPublic(requestParameters, options) {
    return ApplicationPathTagPublicControllerApiFp(this.configuration).getApplicationPathTagsPublic(requestParameters, options)(this.axios, this.basePath);
  }
}
const getApplicationPathTagsPublicRemote = makeRemoteWithOpenapiGenerator({
  requestArgsCreator: ApplicationPathTagPublicControllerApiAxiosParamCreator().getApplicationPathTagsPublic,
  requestFn: ApplicationPathTagPublicControllerApiFp().getApplicationPathTagsPublic
});

export { ApplicationPathTagPublicControllerApi, ApplicationPathTagPublicControllerApiAxiosParamCreator, ApplicationPathTagPublicControllerApiFactory, ApplicationPathTagPublicControllerApiFp, getApplicationPathTagsPublicRemote };
//# sourceMappingURL=application-path-tag-public-controller-api.mjs.map
